import { Flex, Grid, GridItem, InputLeftElement } from "@chakra-ui/react";
import React, { useCallback, useEffect } from "react";
import { QuoteApi } from "../../api/QuoteApi";
import { SelectItem } from "../../lib/types/SelectItem";
import FormSectionHeader from "../common-quote/FormSectionHeader";
import BorrowerTierSlider from "../form-fields/BorrowerTierSlider";
import CheckboxField from "../form-fields/CheckboxField";
import SelectField from "../form-fields/SelectField";
import TextInputField from "../form-fields/TextInputField";
import ShowForRole from "../ShowForRole";

function BorrowerInformationForm() {
  const _isMounted = React.useRef(true);
  const firstUpdate = React.useRef(true);
  const [wholesalePartners, setWholesalePartners] = React.useState<
    SelectItem[]
  >([]);

  const getWholesaleSelect = useCallback(() => {
    QuoteApi.getWholesalePartners()
      .then((res) => {
        const partners = res.data;
        const partnersArray: SelectItem[] = partners.map((partner) => {
          return {
            label: partner.wholesalePartner,
            value: partner.wholesalePartner,
          };
        });
        if (_isMounted.current || firstUpdate.current) {
          partnersArray && setWholesalePartners(partnersArray);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, [setWholesalePartners]);

  useEffect(() => {
    return () => {
      _isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    getWholesaleSelect();
  }, [getWholesaleSelect]);

  useEffect(() => {
    if (_isMounted.current || firstUpdate.current) {
      getWholesaleSelect();
    }
  }, [getWholesaleSelect]);

  React.useEffect(() => {
    return () => {
      _isMounted.current = false;
    };
  }, []);

  return (
    <Grid templateColumns="repeat(12, 1fr)" gap={{ base: 6, md: 8, lg: 8 }}>
      <GridItem colSpan={12}>
        <FormSectionHeader
          id="borrower-information"
          label="Borrower Information"
        />
      </GridItem>

      <GridItem colSpan={{ base: 12, lg: 6 }}>
        <TextInputField label="Primary Guarantor" name="primaryGuarantor" />
      </GridItem>

      <GridItem colSpan={{ base: 12, lg: 6 }}>
        <TextInputField label="Secondary Guarantor" name="secondaryGuarantor" />
      </GridItem>

      <GridItem colSpan={{ base: 12, lg: 6 }}>
        <TextInputField label="Borrowing Entity" name="borrowingEntity" />
      </GridItem>

      <GridItem colSpan={{ base: 12, lg: 6 }}>
        <BorrowerTierSlider
          label="FixNFlip Tier"
          altLabel="New Construction Tier"
          name="borrowerTier"
        />
      </GridItem>

      <GridItem colSpan={{ base: 12, lg: 6 }}>
        <TextInputField
          label="Qualifying FICO"
          name="qualifyingFICO"
          type="number"
        />
      </GridItem>

      <GridItem colSpan={{ base: 12, lg: 6 }}>
        <TextInputField
          label="Combined Liquidity"
          name="combinedLiquidity"
          type="number"
          formatNumber
          children={<InputLeftElement children="$" />}
        />
      </GridItem>

      <ShowForRole roles={["Broker Manager"]}>
        <GridItem colSpan={{ base: 12, lg: 6 }}>
          <SelectField
            label="Wholesale Partner"
            name="wholesalePartner"
            placeholder="Select Wholesale Partner"
            data={wholesalePartners}
          />
        </GridItem>
      </ShowForRole>

      <GridItem alignSelf="center" colSpan={{ base: 12, lg: 6 }}>
        <Flex justify="space-between">
          <CheckboxField label="Is borrower a US Citizen?" name="usCitizen" />
        </Flex>
      </GridItem>
    </Grid>
  );
}

export default BorrowerInformationForm;
